/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-27 08:00:00
 *
 *******************************************************/
// @flow

import React from 'react';
import { Modal, Button, Icon } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { checkDateCountDown } from 'src/helpers/dashboard-helper';
import { Xmas22Constants } from 'src/constants/campaigns';
import xmas22Banner from 'src/assets/images/campaigns/xmas2022.png';
import history from 'src/routes/history';
import './bfcm2022.css';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleExplore: () => void
};

type ComposedProps = Props & WithI18nProps;
const SpecialDiscountWelcomeModal: React.FC<ComposedProps> = ({ active, i18n, onClose }) => {
  const handleCancel = () => {
    onClose();
  };

  const handleExplore = () => {
    history.push({
      pathname: '/plan-discount',
      search: '?&itm_source=inapp&itm_medium=select-plan&itm_campaign=xmas22'
    });
  };

  const countdown = checkDateCountDown(Xmas22Constants.endDate);
  const countdownText =
    countdown > 1
      ? `${countdown} ${i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_days`)}`
      : `${countdown} ${i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_day`)}`;

  return (
    <div className="">
      <Modal open={active} onClose={handleCancel} titleHidden noScroll>
        <div className="bfcm2022">
          <div className="closeBtn">
            <button onClick={handleCancel}>
              <Icon source={MobileCancelMajor} color="base" />
            </button>
          </div>
          <div>
            <h1>{i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_h1`)}</h1>
          </div>
          <div>
            <h2>December 14, 2022 - December 23, 2022</h2>
          </div>
          <div className="sub-title">
            {i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_sub_title`, {
              off: (
                <b>
                  {i18n.translate(
                    `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_sub_title_off`
                  )}
                </b>
              ),
              code: (
                <b>
                  {i18n.translate(
                    `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_sub_title_code`
                  )}
                </b>
              )
            })}
          </div>
          <div>
            <img src={xmas22Banner} alt="xmas-banner" width="580" height="280" />
          </div>
          <div className="action">
            <Button primary size="large" onClick={handleExplore}>
              {i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2021_Explore_Now`)}
            </Button>
          </div>
          {countdown <= 5 && countdown >= 0 && (
            <div>
              <div className="countdown-warning">
                <span>
                  {countdown > 0
                    ? i18n.translate(
                        `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_countdown`,
                        { daysLeft: countdownText }
                      )
                    : i18n.translate(
                        `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Popup_countdown_hours`
                      )}
                </span>
              </div>
            </div>
          )}
          <div className="no-thank"></div>
        </div>
      </Modal>
    </div>
  );
};

export default withI18n()(SpecialDiscountWelcomeModal);
